import React from "react";
import { NavLink } from "react-router-dom";
import { FaChevronLeft, FaChevronRight, FaGlobeEurope } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";

import SidebarSection from "./SidebarSection";
import { ADMIN_NAVBAR_OFFSET } from "../data/adminShellConfig";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function DesktopSidebar({
  shellWidth,
  isCollapsed,
  pathname,
  visibleSections,
  onToggleCollapsed,
}) {
  return (
    <aside
      className={cn(
        "fixed left-0 z-40 hidden flex-col border-r border-slate-200/80 bg-white/95 backdrop-blur-xl transition-all duration-300 dark:border-slate-800/80 dark:bg-slate-950/95 lg:flex",
        shellWidth,
      )}
      style={{
        top: ADMIN_NAVBAR_OFFSET,
        height: `calc(100dvh - ${ADMIN_NAVBAR_OFFSET})`,
      }}
    >
      <div className="px-3 pb-3 pt-4">
        <div
          className={cn(
            "overflow-hidden rounded-[1.7rem] border border-sky-100 bg-gradient-to-br from-sky-50 via-white to-cyan-50 shadow-sm dark:border-sky-500/10 dark:from-slate-900 dark:via-slate-900 dark:to-sky-950/40",
            isCollapsed ? "p-2" : "p-4",
          )}
        >
          <div
            className={cn(
              "flex items-center",
              isCollapsed ? "justify-center" : "justify-between gap-3",
            )}
          >
            <div
              className={cn(
                "flex items-center",
                isCollapsed ? "justify-center" : "gap-3",
              )}
            >
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-[#1277B9] to-cyan-400 text-lg text-white shadow-lg shadow-sky-500/25">
                <MdDashboard />
              </div>

              {!isCollapsed ? (
                <div className="min-w-0">
                  <p className="text-sm font-bold text-slate-950 dark:text-white">
                    Admin Mairie
                  </p>
                  <p className="mt-0.5 text-xs leading-5 text-slate-500 dark:text-slate-400">
                    Gestion simple du site municipal
                  </p>
                </div>
              ) : null}
            </div>

            {!isCollapsed ? (
              <button
                type="button"
                onClick={onToggleCollapsed}
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800"
                aria-label="Replier le menu"
              >
                <FaChevronLeft />
              </button>
            ) : null}
          </div>

          {isCollapsed ? (
            <button
              type="button"
              onClick={onToggleCollapsed}
              className="mt-2 flex h-10 w-full items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800"
              aria-label="Déplier le menu"
            >
              <FaChevronRight />
            </button>
          ) : null}
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-1 pb-4">
        {visibleSections.map((section) => (
          <SidebarSection
            key={section.label}
            section={section}
            pathname={pathname}
            isCollapsed={isCollapsed}
          />
        ))}
      </div>

      <div className="border-t border-slate-200/80 px-3 py-4 dark:border-slate-800/80">
        <NavLink
          to="/"
          className={cn(
            "group flex items-center rounded-[1.35rem] border border-slate-200 bg-white px-3 py-3 text-sm font-bold text-slate-700 shadow-sm transition hover:border-sky-200 hover:bg-sky-50 hover:text-sky-700 hover:shadow-md dark:border-slate-800 dark:bg-slate-900 dark:text-slate-200 dark:hover:border-sky-500/30 dark:hover:bg-sky-500/10 dark:hover:text-sky-300",
            isCollapsed ? "justify-center" : "gap-3",
          )}
          title="Voir le site public"
        >
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-sky-50 text-sky-700 transition group-hover:scale-105 dark:bg-sky-500/10 dark:text-sky-300">
            <FaGlobeEurope />
          </span>

          {!isCollapsed ? (
            <span className="min-w-0">
              <span className="block truncate">Voir le site public</span>
              <span className="mt-0.5 block truncate text-xs font-medium text-slate-400 dark:text-slate-500">
                Retour à la page d’accueil
              </span>
            </span>
          ) : null}
        </NavLink>
      </div>
    </aside>
  );
}